// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Z8_y","productName":"Table_productName__KpvJ-"};